"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeLinkStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeLinkStyles = function makeLinkStyles(_ref) {
  var tokens = _ref.tokens;
  return {
    MuiLink: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({
          textDecorationSkipInk: "auto"
        }, tokens.textLink.defaultState), {}, {
          '&[class*="MuiLink-underlineHover"]': {
            textDecoration: tokens.textLink.defaultState.textDecoration
          },
          '&[class*="MuiTypography-root"]': {
            "&:visited": tokens.textLink.visitedState,
            "&:hover, &:visited:hover": tokens.textLink.hoverState,
            "&:focus-visible": tokens.textLink.focusState,
            "&:active": tokens.textLink.pressedState,
            "&[disabled]": _objectSpread(_objectSpread({}, tokens.opacities.disabled), {}, {
              pointerEvents: "none",
              cursor: "default"
            })
          }
        }),
        underlineNone: {
          textDecoration: "none"
        }
      }
    }
  };
};

exports.makeLinkStyles = makeLinkStyles;